import { IndustrySectorsParser } from '@services/http/parsers/industry-sectors-response.parser';
import { SnfIntlHttpRemoteCall } from '../snf-intl.http-remote-call';

export class GetAllIndustrySectorsRemoteCall extends SnfIntlHttpRemoteCall {
  /**
   * @inheritdoc
   */
  relativePath = 'industries';

  /**
   * @inheritdoc
   */
  responseParser = new IndustrySectorsParser();

  cache = true;

  getQuery() {
    return {
      ...super.getQuery()
    };
  }
}
